import { render, staticRenderFns } from "./CatchphraseSection.vue?vue&type=template&id=4bf575f6&scoped=true&"
import script from "./CatchphraseSection.vue?vue&type=script&lang=js&"
export * from "./CatchphraseSection.vue?vue&type=script&lang=js&"
import style0 from "./CatchphraseSection.vue?vue&type=style&index=0&id=4bf575f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf575f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
